import { nativeIsArray } from './_setup.js';
import tagTester from './_tagTester.js';

// Is a given value an array?
// Delegates to ECMA5's native `Array.isArray`.
export default nativeIsArray || tagTester('Array');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isArray.js
// module id = 54
// module chunks = 0